import { Controller } from "@hotwired/stimulus"
import { setSelectedValues } from "../shared/multi_select"

export default class extends Controller {
  static targets = ["department"]

  changeCompany(event) {
    setSelectedValues(this.departmentTarget, [])
    event.currentTarget.form.requestSubmit()
  }
}
